<template>
  <router-link 
    :to="to"
    class="BtnClose">
    <font-awesome-icon :icon="['fal', 'times-circle']" />
  </router-link>
</template>

<script>
export default {
  name: 'BtnClose',
  props: {
    to: {
      type: Object,
      required: true
    }
  }
}
</script>

<style lang="scss"> 
  .BtnClose {
    text-decoration: none;
    padding: 4px;
    position: absolute;
    top: 32px;
    right: 24px;
    font-family: $font_nav;
    user-select: none;
    font-size: 24px;
    color: white;

    &:hover {
      color: $black;
    }
  }

</style>
